import * as React from 'react';
import './ShortcutEntry.less';

interface IShortcutEntryPropType {
    prefixCls?: string;
    floorItem?: object;
    bgData?: any;
    onEntryClick?: (item: any) => void;
    data?: any;
}

class ShortcutEntry extends React.Component<IShortcutEntryPropType, any> {
    static defaultProps = {
        prefixCls: 'shortcut'
    };

    render() {
        const {prefixCls, onEntryClick, data, bgData = {}} = this.props;
        let bgStyle: any = {};
        if (bgData) {
            bgStyle = {
                backgroundColor: bgData.backgroundColour,
                backgroundImage: `url(${bgData.backgroundImg})`,
                backgroundSize: '100% 100%'
            }
        }
        return (
            <div className={`${prefixCls} clearfix`} style={bgData ? bgStyle : {}}>
                {
                    data.map((item: any) => {
                        return (
                            <div className={`${prefixCls}-item`} key={item.id} onClick={() => {onEntryClick && onEntryClick(item)}}>
                                <img src={item.iconImg} alt=""/>
                                <p>{item.name}</p>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export default ShortcutEntry;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/shortcutEntry/ShortcutEntry.tsx